import { WorkflowRunState } from '@smartsheet-bridge/bridge-sdk/es/http';
import { isNil } from 'ramda';
import { UIWorkflowRunState } from '../services/ducks/workflowDuck/workflowDuck';
import {
  AnyWorkflowNode,
  GroupWorkflowNode,
  JunctionWorkflowNode,
  TransitWorkflowNode,
} from './workflowTree';
import { WorkflowFns } from './workflowVisitor';

export const hasTransitEntity = (
  node: TransitWorkflowNode | JunctionWorkflowNode
): boolean => {
  return (
    !isNil(node.meta.entities) &&
    !isNil(node.meta.entities?.[node.id]) &&
    node.meta.entities?.[node.id] !== '' &&
    node.meta.entities?.[node.id] !== '?'
  );
};

export const getTransitEntity = (
  node: TransitWorkflowNode | JunctionWorkflowNode
): string => {
  return (
    (!isNil(node.meta.entities) &&
      !isNil(node.meta.entities?.[node.id]) &&
      node.meta.entities?.[node.id]) ||
    ''
  );
};

export const matchTransitEntity =
  (strToMatch: string) =>
  (node: TransitWorkflowNode | JunctionWorkflowNode): boolean => {
    return hasTransitEntity(node) && getTransitEntity(node) === strToMatch;
  };

export const convertWorkflowRunStateToUI = (state: WorkflowRunState) => {
  switch (state) {
    case WorkflowRunState.AWAITING_USER_INPUT:
      return UIWorkflowRunState.WAITING_ON_CHATBOT_REPLY;
    case WorkflowRunState.AWAITING_ADMIN_INPUT:
      return UIWorkflowRunState.STOPPED_BY_ERROR;
    case WorkflowRunState.ON_HOLD:
      return UIWorkflowRunState.WAITING;
    case WorkflowRunState.STOPPED:
      return UIWorkflowRunState.STOPPED;
    case WorkflowRunState.DONE:
      return UIWorkflowRunState.DONE;
    default:
    case WorkflowRunState.IN_PROGRESS:
      return UIWorkflowRunState.IN_PROGRESS;
  }
};

export const getAllGroupNames = (root: GroupWorkflowNode) => {
  const allNames: string[] = [];

  WorkflowFns.traverseDepthFirst({
    TransitStep: node => {
      if (node.meta.groupName === root.id) {
        allNames.push(node.id);
      }
      return node;
    },
    JunctionStep: node => {
      if (node.meta.groupName === root.id) {
        allNames.push(node.id);
      }
      return node;
    },
  })(root.meta);

  return allNames;
};

export const getExitPathNode = (root: GroupWorkflowNode) => {
  const exit = (n: AnyWorkflowNode) => (n.next.length === 1 ? n.next[0] : n);
  return WorkflowFns.traverseDepthFirst({
    TransitStep: { exit },
    ModuleStep: { exit },
    GroupExitStep: {
      exit: node => node.meta,
    },
    JunctionStep: {
      enter: node => ({
        ...node,
        next: node.next.filter(matchTransitEntity(getTransitEntity(node))),
      }),
      exit,
    },
  })(root.meta);
};

export const getGroupOutput = (root: GroupWorkflowNode) => {
  let output: any;

  WorkflowFns.traverseDepthFirst({
    ModuleStep: node => {
      output = !isNil(node.meta.metadata)
        ? node.meta.metadata.output
        : undefined;
      return { ...node, next: [] };
    },
  })(root.meta);

  return output;
};
